import { IServerResponse } from "@/api/types";
import { axiosInstance } from "@/api/index";
import { API_EVENT_TRACER, API_EVENT_TRACER_BFF } from "@/configs/global";
import { AxiosResponse } from "axios";
import { EventTrace, EventTraceDTO, OneEventTraceDTO } from "@/api/types/event-tracer";

/* Получение списка событий. Через BFF: он отдаёт готовые ячейки таблицы */
export async function getEventTraces(data: EventTraceDTO, isExport?: boolean): Promise<IServerResponse<EventTrace[]>> {
    const headers = isExport ? { 'Accept': "text/csv" } : {};
    return axiosInstance.request<IServerResponse<EventTrace[]>>({
        method: 'POST',
        url: `${API_EVENT_TRACER_BFF}/employees/autostats-list`,
        data,
        headers,
    })
        .then((response: AxiosResponse<IServerResponse<EventTrace[]>>) => response.data);
}

/* Получение одного события. Напрямую в апстрим: нужны сырые поля, а не ячейки */
export async function getOneEventTrace(data: OneEventTraceDTO): Promise<IServerResponse<EventTrace[]>> {
    return axiosInstance.request<IServerResponse<EventTrace[]>>({
        method: 'POST',
        url: `${API_EVENT_TRACER}/employees/events`,
        data,
    })
        .then((response: AxiosResponse<IServerResponse<EventTrace[]>>) => response.data);
}
